module.exports = __webpack_public_path__ + "components/flag/static/square/eu-ab50940ee94db5e6ec0db1701262a5a2.svg";